var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "cursor-pointer",
        attrs: {
          "bg-icon": _vm.getBgIcon(),
          icon: _vm.getIcon(),
          reverse: "",
          title: _vm.title,
          "title-class": "mb-1 bg-transparent"
        },
        on: {
          "on-click": function($event) {
            _vm.isVisible = !_vm.isVisible
          }
        }
      }),
      _c("transition", { attrs: { name: "list" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisible,
                expression: "isVisible"
              }
            ],
            staticClass: "card-body p-0 mb-4 ml-3"
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }